<ul class="senha-checklist" aria-label="Requisitos de senha">
  <li class="checklist-item" [class.cumprido]="temMinLength">
    <span class="icon-wrap" aria-hidden="true">
      <i class="pi" [ngClass]="temMinLength ? 'pi-check' : 'pi-circle'"></i>
    </span>
    <span>Mínimo de 8 caracteres</span>
  </li>
  <li class="checklist-item" [class.cumprido]="temMaiuscula">
    <span class="icon-wrap" aria-hidden="true">
      <i class="pi" [ngClass]="temMaiuscula ? 'pi-check' : 'pi-circle'"></i>
    </span>
    <span>Pelo menos 1 letra maiúscula</span>
  </li>
  <li class="checklist-item" [class.cumprido]="temNumero">
    <span class="icon-wrap" aria-hidden="true">
      <i class="pi" [ngClass]="temNumero ? 'pi-check' : 'pi-circle'"></i>
    </span>
    <span>Pelo menos 1 número</span>
  </li>
  <li class="checklist-item" [class.cumprido]="temEspecial">
    <span class="icon-wrap" aria-hidden="true">
      <i class="pi" [ngClass]="temEspecial ? 'pi-check' : 'pi-circle'"></i>
    </span>
    <span>Pelo menos 1 caractere especial</span>
  </li>
</ul>
